import { c as _c } from "react/compiler-runtime";
import { Badge, type BadgeProps } from "@/components/ui/badge";
import type { ErrorInfo, ErrorCategory } from "@/types/runStream";
const CATEGORY_CONFIG: Record<ErrorCategory, {
  label: string;
  variant: BadgeProps["variant"];
}> = {
  funds: {
    label: "Funds",
    variant: "warning"
  },
  amount: {
    label: "Amount",
    variant: "warning"
  },
  config: {
    label: "Config",
    variant: "info"
  },
  auth: {
    label: "Auth",
    variant: "purple"
  },
  network: {
    label: "Network",
    variant: "cyan"
  },
  service: {
    label: "Service",
    variant: "info"
  },
  onchain: {
    label: "On-chain",
    variant: "destructive"
  },
  validation: {
    label: "Validation",
    variant: "default"
  },
  internal: {
    label: "Internal",
    variant: "destructive"
  }
};
export function ErrorCategoryBadge(t0) {
  const $ = _c(3);
  const {
    category
  } = t0;
  const config = CATEGORY_CONFIG[category];
  if (!config) {
    return null;
  }
  let t1;
  if ($[0] !== config.label || $[1] !== config.variant) {
    t1 = <Badge variant={config.variant}>{config.label}</Badge>;
    $[0] = config.label;
    $[1] = config.variant;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

/**
 * Category badge + optional "Retryable" badge. Used wherever both
 * badges appear together (UnifiedErrorPanel, FailedNodeErrorSection,
 * FailedNodePanel).
 */
export function ErrorStatusBadges(t0) {
  const $ = _c(7);
  const {
    errorInfo
  } = t0;
  let t1;
  if ($[0] !== errorInfo.category) {
    t1 = <ErrorCategoryBadge category={errorInfo.category} />;
    $[0] = errorInfo.category;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== errorInfo.retryable) {
    t2 = errorInfo.retryable && <Badge variant="success">Retryable</Badge>;
    $[2] = errorInfo.retryable;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}